import { WalkInRequest, Urls } from '@2meters/types'
import { functions } from 'api/Firebase/firebase-init'
import { httpsCallable } from 'firebase/functions'

export function walkInCallable(request: WalkInRequest) {
  const walkInCloudFunc = httpsCallable(functions, Urls.visitor.prefix + Urls.visitor.walkIn)

  return walkInCloudFunc(request)
}
